const setItem = (key, value) => {
  if (value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }
};

const getItem = (key) => {
  const itemStr = sessionStorage.getItem(key);
  if (itemStr) {
    return JSON.parse(itemStr);
  }
  return null;
};

const clear = () => {
  sessionStorage.clear();
  window.location.reload();
};

const setLocalItem = (key, value) => {
  if (value) {
    localStorage.setItem(key, JSON.stringify(value));
  }
};

const getLocalItem = (key) => {
  const itemStr = localStorage.getItem(key);
  if (itemStr) {
    return JSON.parse(itemStr);
  }
  return null;
};

const localClear = () => {
  localStorage.clear();
};

const appdata = {
  setItem,
  getItem,
  clear,
  setLocalItem,
  getLocalItem,
  localClear,
};

export default appdata;
